<template>
  <div class="task taskSearcher">
    <transition name="fade" mode="out-in">
      <searcher
        :contentId="definitionId"
        :fromTask="true"
        :endpointTask="task.type.endpoint"
        :id="definitionContentId"
        :code="repeatableGroupCode"
        :menuId="task.menuId"
        :taskObject="object"
        :istoggle="istoggle"
        @refreshDefinitionContent="refreshDefinitionContent"
      />
    </transition>
  </div>
</template>

<script>
import language from '../../language'

export default {
  name: 'definition-task-searcher',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'apiparams',
    'visuals',
    'istoggle'
  ],
  components: {
    Searcher: () => import('@/components/content/searcher/index.vue') // comment for 'definition.js' low size // Webpack’s asynchronous import for recursivity components
  },
  data () {
    return {
    }
  },
  methods: {
    getLang (key) {
      return language(this.language, key)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// node_modules/vue-definition/src/components/item/task/taskSearcher.vue